module.exports = __webpack_public_path__ + "static/img/progress.88a11601.png";